<template>
  <div class="modal-overflow" style="padding: 0 10px;">
    <div class="row">
      <div class="col-md-2">
        <div style="margin-top:15px;" class="form-group">
          <h6>Price Rule Fields</h6>
        </div>
        <div class="form-group" style="margin-top: -2px;">
          <label>Department</label>
          <el-select class="select"
                     name="department"
                     size="large"
                     clearable
                     @change="setDepartmentId"
                     data-vv-as="department"
                     placeholder="Department"
                     v-validate="modelValidations.department"
                     v-model="edit.department">
            <el-option v-for="option in departments"
                       class="select"
                       :value="option.label"
                       :label="option.label"
                       :key="option.label"/>
          </el-select>
          <small class="text-danger" v-show="errors.has('department')">
            {{ getError('department') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group m-top-40">
          <label>Project Type</label>
          <el-select class="select"
                     size="large"
                     clearable
                     name="projectType"
                     data-vv-as="project type"
                     placeholder="Project Type"
                     v-validate="modelValidations.projectType"
                     v-model="edit.projectType">
            <el-option v-for="option in projectTypes"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label"/>
          </el-select>
          <small class="text-danger" v-show="errors.has('projectType')">
            {{ getError('projectType') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group m-top-40">
          <label>Price</label>
            <vue-numeric
              currency="$"
              separator=","
              :precision="2"
              :minus="false"
              data-vv-as="price"
              name="price"
              class="twenty-five-percent el-input__inner"
              v-model="edit.price"
              v-validate="modelValidations.price"
              placeholder="Price"></vue-numeric>
          <small class="text-danger" v-show="errors.has('price')">
              {{ getError('price') }}
          </small>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group m-top-40">
          <label>Hourly</label>
          <p-switch type="primary"
                    on-text="YES"
                    off-text="NO"
                    style="display:block; margin-top: 14px;"
                    @input="maybeClearHourlyRate"
                    v-model="edit.hourly"></p-switch>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group m-top-40">
          <label>Hourly Rate</label>
          <vue-numeric
            currency="$"
            separator=","
            :precision="2"
            :minus="false"
            :disabled="isNotHourlyPriceRule"
            data-vv-as="hourly rate"
            name="hourlyRate"
            class="twenty-five-percent el-input__inner"

            v-model="edit.hourlyRate"
            v-validate="'hourlyHasRate'"
            placeholder="Hourly rate"></vue-numeric>
          <small class="text-danger" v-show="errors.has('hourlyRate')">
            {{ getError('hourlyRate') }}
          </small>
        </div>
      </div>
      <div class="col-md-3 m-top-40">
        <label>
          QB Class
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              NOTE: If you specify a QuickBooks class here,
              it will override the class configured on the Task Name if / when this price rule is applied to an
              invoice submittal task.
            </div>
            <img class="icon-help m-left-4" src="static/img/icon-info.png"  alt="QB Class Usage"/>
          </el-tooltip>
        </label>
        <el-select class="select"
                   size="large"
                   name="qbClass"
                   style="width: 100%"
                   placeholder="QB Class"
                   v-model="edit.qbClass">
          <el-option v-for="option in constants.QUICKBOOKS.CLASSES"
                     class="select"
                     :value="option"
                     :label="option"
                     :key="option">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Task Name</label>
          <v-select
            name="selectedTaskName"
            v-model="selectedTaskName"
            v-validate="taskNameOrJobName"
            @input="setTaskNameIdAndName"
            placeholder="Task Name"
            label="label"
            value="value"
            :options="taskNamesForSelect">
          </v-select>
          <small class="text-danger" v-show="errors.has('selectedTaskName')">
            The Task Name or Job Name field is required but not both. If Project Default is YES, Client Default is YES, or Location is YES, then both Task Name and Job Name must be left blank.
          </small>
        </div>
      </div>
      <div class="col-md-1" style="text-align: center; padding-top: 24px;">
        <h5>OR</h5>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>
            Job Name
            <el-tooltip class="item" effect="dark" content="If no department is selected, your default department is used to filter the list of available jobs." placement="top-start">
              <img class="icon-help" src="static/img/icon-info.png"  alt="Jobs are filtered by department"/>
            </el-tooltip>
          </label>
          <v-select
            name="selectedJobName"
            v-model="selectedJobName"
            v-validate="taskNameOrJobName"
            @input="setJobName"
            placeholder="Job Name"
            label="label"
            value="value"
            :options="jobNames">
          </v-select>
          <small class="text-danger" v-show="errors.has('selectedJobName')">
            The Task Name or Job Name field is required but not both. If Project Default is YES, Client Default is YES, or Location is YES, then both Task Name and Job Name must be left blank.
          </small>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <label>Repeated Task</label>
          <p-switch type="primary"
                    on-text="YES"
                    off-text="NO"
                    style="display:block; margin-top: 14px;"
                    v-model="edit.repeatedTask"></p-switch>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Travel Charge</label>
          <p-switch type="primary"
                    on-text="YES"
                    off-text="NO"
                    style="display:block; margin-top: 14px;"
                    v-model="edit.travelCharge"></p-switch>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
            <label>Client</label>
            <el-autocomplete
              style="width:100%"
              name="client"
              data-vv-as="client"
              class="inline-input"
              :clearable="true"
              v-model="selectedClient.name"
              :fetch-suggestions="findClients"
              :trigger-on-focus="false"
              ref="clientId"
              value-key="name"
              v-validate.continues="'clientDefaultHasClient|locationHasClientOrProject'"
              @blur="verifyClientAutocompleteSelected"
              placeholder="Client"
              @select="setClient">
            </el-autocomplete>
          <small class="text-danger" v-show="errors.has('client')">
            {{ getError('client') }}
          </small>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('clientId')">
            {{ fieldNotValidError('Client') }}
          </small>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <label>Client Default</label>
          <p-switch type="primary"
                    on-text="YES"
                    off-text="NO"
                    v-validate="'clientDefaultOrLocationOrProjectDefault'"
                    name="clientDefault"
                    style="display:block; margin-top: 14px;"
                    v-model="edit.clientDefault"></p-switch>
          <small class="text-danger" v-show="errors.has('clientDefault')">
            <template v-if="this.edit.clientDefault && this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Client Default and Project Default, and Location.
            </template>
            <template v-else-if="this.edit.clientDefault && this.edit.projectDefault && !this.edit.location">
              Price Rule cannot be Client Default and Project Default.
            </template>
            <template v-else-if="this.edit.clientDefault && !this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Client Default and Location.
            </template>
            <template v-else-if="!this.edit.clientDefault && this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Project Default and Location.
            </template>
            If Client Default is YES, you must select a client.
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Location</label>
          <p-switch type="primary"
                    on-text="YES"
                    off-text="NO"
                    v-validate="'clientDefaultOrLocationOrProjectDefaultAndLocationHasAddressFields'"
                    name="location"
                    style="display:block; margin-top: 14px;"
                    v-model="edit.location"></p-switch>
          <small class="text-danger" v-show="errors.has('location')">
            <template v-if="this.edit.clientDefault && this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Location, Client Default, and Project Default.
            </template>
            <template v-else-if="this.edit.clientDefault && this.edit.projectDefault && !this.edit.location">
              Price Rule cannot be Client Default and Project Default.
            </template>
            <template v-else-if="this.edit.clientDefault && !this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Client Default and Location.
            </template>
            <template v-else-if="!this.edit.clientDefault && this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Location and Project Default.
            </template>
            If location is YES, you must select a Client and/or a Project, a City, and at least two address fields.
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Builder</label>
          <el-autocomplete
            style="width:100%"
            name="builder"
            data-vv-as="builder"
            class="inline-input"
            :debounce="150"
            :clearable="true"
            v-model="selectedBuilder.name"
            :fetch-suggestions="findBuilders"
            :trigger-on-focus="false"
            ref="builderId"
            value-key="name"
            placeholder="Builder"
            @blur="verifyBuilderAutocompleteSelected"
            @select="setBuilder">
          </el-autocomplete>
          <small class="text-danger" v-show="errors.has('builder')">
            {{ getError('builder') }}
          </small>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('builderId')">
            {{ fieldNotValidError('Builder') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Project Name</label>
          <el-input type="text"
                 name="projectName"
                 placeholder="Project Name"
                 data-vv-as="project name"
                 v-validate.continues="'projectDefaultHasProject|locationHasClientOrProject'"
                 v-model="edit.projectName"
                 clearable/>
          <small class="text-danger" v-show="errors.has('projectName')">
            {{ getError('projectName') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Project Default</label>
          <p-switch type="primary"
                    on-text="YES"
                    off-text="NO"
                    v-validate.continues="'projectDefaultHasProject|clientDefaultOrLocationOrProjectDefault'"
                    name="projectDefault"
                    style="display:block; margin-top: 14px;"
                    v-model="edit.projectDefault"></p-switch>
          <small class="text-danger" v-show="errors.has('projectDefault')">
            <template v-if="this.edit.clientDefault && this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Project Default, Client Default, and Location
            </template>
            <template v-else-if="this.edit.clientDefault && this.edit.projectDefault && !this.edit.location">
              Price Rule cannot be Project Default and Client Default.
            </template>
            <template v-else-if="!this.edit.clientDefault && this.edit.projectDefault && this.edit.location">
              Price Rule cannot be Project Default and Location.
            </template>
            If Project Default is YES, you must enter a project name (name must match exactly).
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Building Number</label>
          <el-input type="text"
                 name="buildingNumber"
                 placeholder="Building Number"
                 data-vv-as="building number"
                 v-model="edit.buildingNumber"
                 clearable />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Suite Number</label>
          <el-input type="text"
                 name="suiteNumber"
                 placeholder="Suite Number"
                 data-vv-as="suite number"
                 v-model="edit.suiteNumber"
                 clearable />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Floor Number</label>
          <el-input type="text"
                 name="floorNumber"
                 placeholder="Floor Number"
                 data-vv-as="floor number"
                 v-model="edit.floorNumber"
                 clearable />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>City</label>
          <el-autocomplete
            style="width:100%"
            class="inline-input"
            name="city"
            ref="city"
            :clearable="true"
            :debounce="150"
            v-model="localCity"
            :fetch-suggestions="findCities"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="City"
            @blur="verifyCityAutocompleteSelected"
            data-vv-as="city"
            @select="setCityLoadCounties">
          </el-autocomplete>
          <small class="text-danger" v-show="errors.has('city')">
            {{ getError('city') }}
          </small>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('city')">
            {{ fieldNotValidError('City') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Street Number</label>
          <el-input type="text"
                name="streetNumber"
                placeholder="Street Number"
                data-vv-as="street number"
                v-model="edit.streetNumber"
                clearable />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Street Name</label>
          <el-autocomplete
            name="streetName"
            ref="streetName"
            style="width:100%"
            class="inline-input"
            :clearable="true"
            :debounce="150"
            data-vv-name="street name"
            v-model="localStreetName"
            data-vv-as="street name"
            :fetch-suggestions="findStreets"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Street Name"
            @focus="verifyCitySelected"
            @blur="verifyStreetNameAutocompleteSelected"
            @select="setStreet">
          </el-autocomplete>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('streetName')">
            {{ fieldNotValidError('Street Name') }}
          </small>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>County</label>
          <el-select class="select"
                     size="large"
                     name="county"
                     placeholder="County"
                     @focus="verifyCitySelected"
                     v-model="edit.county">
            <el-option v-for="option in counties"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>State</label>
          <el-select class="select"
                     name="state"
                     size="large"
                     clearable
                     placeholder=""
                     data-vv-as="state"
                     v-model="edit.state">
            <el-option v-for="option in states"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('state')">
            {{ getError('state') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Jurisdiction</label>
          <el-select class="select"
                     name="jurisdiction"
                     size="large"
                     clearable
                     placeholder="Jurisdiction"
                     data-vv-as="jurisdiction"
                     v-model="edit.jurisdiction">
            <el-option v-for="option in constants.JURISDICTIONS"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('jurisdiction')">
            {{ getError('jurisdiction') }}
          </small>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Community</label>
          <el-autocomplete
            style="width:100%"
            name="community"
            ref="community"
            class="inline-input"
            :clearable="true"
            :debounce="150"
            v-model="localCommunity"
            :fetch-suggestions="findCommunities"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Community"
            @blur="verifyCommunityAutocompleteSelected"
            data-vv-as="community"
            @select="setCommunity">
          </el-autocomplete>
          <small class="text-danger" v-show="errors.has('community')">
            {{ getError('community') }}
          </small>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('community')">
            {{ fieldNotValidError('Community') }}
          </small>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Legal Subdivision</label>
          <el-autocomplete
            style="width:100%"
            name="legalSubdivision"
            ref="legalSubdivisionId"
            class="inline-input"
            :clearable="true"
            :debounce="150"
            data-vv-name="legal subdivision"
            v-model="localLegalSubdivision"
            data-vv-as="legal subdivision"
            :fetch-suggestions="findLegalSubdivisions"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Legal Subdivision"
            @blur="verifyLegalSubdivisionAutocompleteSelected"
            @select="setLegalSubdivision">
          </el-autocomplete>
          <small class="text-danger" v-show="errors.has('legalSubdivision')">
            {{ getError('legalSubdivision') }}
          </small>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('legalSubdivisionId')">
            {{ fieldNotValidError('Legal Subdivision') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Expiry Date</label>
          <el-date-picker
            type="date"
            name="expiry"
            v-model="expiryDate"
            :format="constants.DATE.FORMAT.DISPLAY"
            :value-format="constants.DATE.FORMAT.VALUE"
            @input="setExpiryDate"
            :picker-options="datePickerConfig"
            placeholder="Expiry">
          </el-date-picker>
          <small class="text-danger" v-show="errors.has('expiry')">
            {{ getError('expiry') }}
          </small>
        </div>
      </div>
    </div>
    <div class="form-group row" style="padding: 0 5px;">
      <label>Notes</label>
      <el-input
        type="textarea"
        name="notes"
        :rows="2"
        v-model="edit.notes" />
    </div>
      <div style="margin-top:15px;" class="form-group" v-if="displayAuditFields">
        <h6>Audit Fields</h6>
        <ul>
          <li v-if="edit.shortId"><strong>Short ID: </strong>{{ edit.shortId }}</li>
          <li v-if="edit.createdAt"><strong>Created on: </strong>{{ edit.createdAt | formatDate }}</li>
          <li v-if="edit.createdBy"><strong>Created by: </strong>{{ getUserDisplayName(edit.createdBy) }}</li>
          <li v-if="edit.updatedAt"><strong>Last Updated on: </strong>{{ edit.updatedAt | formatDate }}</li>
          <li v-if="edit.updatedBy"><strong>Last Updated by: </strong>{{ getUserDisplayName(edit.updatedBy) }}</li>
          <li v-if="edit.lastUsed"><strong>Last Used on: </strong>{{ edit.lastUsed | formatDate }}</li>
        </ul>
      </div>
      <div class="form-group">
        <button type="button" :disabled="isSubmitDisabled" @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">
          Save Price Rule
        </button>
      </div>
  </div>
</template>

<script>
import datePickerConfig from '@/components/UIComponents/DatePicker/datePickerConfig'
import {mapGetters} from 'vuex'
import {mapFields} from 'vee-validate'
import {
  autocompleteReady,
  autocompleteTextButNoValue,
  autocompleteTextButNoValueMessage,
  findCities,
  findCommunities,
  findCompany,
  findLegalSubdivisions,
  findStreets,
  jobNamesForSelect,
  kvpsForSelectFromArray,
  kvpsForSelectTheWorks,
  notifyError,
  notifySuccess,
  objectBy,
  utcToLocal,
  verifyAutocompleteSelected
} from 'src/utilities/utils'
import PSwitch from 'src/components/UIComponents/Switch'
import VueNumeric from 'vue-numeric'
import Constants from 'src/utilities/constants'
import {OK} from 'http-status-codes'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {sync} from 'vuex-pathify'
import _ from 'lodash'

export default {
    props: ['data'],
    components: {
      PSwitch,
      VueNumeric,
      vSelect
    },
    data() {
      return {
        constants: Constants,
        datePickerConfig,
        itemDescription: null,
        isProcessing: false,
        counties: [],
        expiryDate: null,
        localCity: null,
        localCommunity: null,
        selectedClient: { id: null, name: null },
        selectedBuilder: { id: null, name: null },
        localLegalSubdivision: null,
        localStreetName: null,
        selectedTaskName: null,
        selectedJobName: null,
        displayAuditFields: false,
        newCompany: {
          builder: false,
          client: false
        },
        modelValidations: {
          department: {
            required: true
          },
          price: {
            min_value: 0,
            max: 7
          },
          templateName: {
            required: true
          },
          jobName: {
            required: true
          },
          projectType: {
            required: true
          }
        }
      }
    },
    computed: {
      edit: sync('priceRules@edit'),
      ...mapFields([
        'city',
        'streetName',
        'legalSubdivision']
      ),
      ...mapGetters({
        activeModals: 'modalTracker/activeModals',
        departments: 'departments/kvpsForSelectNoIt',
        taskNamesForSelect: 'tasks/names/kvpsForSelect',
        allItemCodes: 'quickbooks/results',
        projectTypes: 'types/project',
        states: 'states',
        autocompleteCommunities: 'communities/results',
        autocompleteClients: 'companies/autocompleteResultsClient',
        autocompleteBuilders: 'companies/autocompleteResultsBuilder',
        autocompleteCities: 'address/cities'
      }),
      isNotHourlyPriceRule() {
        return !this.$store.get('priceRules@edit.hourly')
      },
      isSubmitDisabled() {
        return this.isProcessing
      },
      taskNameOrJobName() {
        const taskName = this.$store.get('priceRules@edit/taskName')
        const jobName = this.$store.get('priceRules@edit/jobName')
        const projectDefault = this.$store.get('priceRules@edit/projectDefault')
        const clientDefault = this.$store.get('priceRules@edit/clientDefault')
        const location = this.$store.get('priceRules@edit/location')

        if (!projectDefault && !clientDefault && !location && !taskName && !jobName) {
          return 'required'
        } else if ((taskName && jobName) || ((projectDefault || clientDefault || location) && (taskName || jobName))) {
          // (both taskName and jobName) OR ((projectDefault true || clientDefault true || location true) AND (taskName OR jobName))
          return {
            is: ''
          }
        }
        return ''
      },
      addressFieldCount() {
        const addressFields = [
          'streetNumber',
          'streetName',
          'buildingNumber',
          'floorNumber',
          'suiteNumber',
          'county',
          'community'
        ]
        let count = 0

        for (const addressField of addressFields) {
          if (_.isString(this.edit[addressField]) && !_.isEmpty(this.edit[addressField])) {
            count++
          }
        }

        return count
      },
      jobNames() {
        const departmentId = this.$store.get('priceRules@edit.departmentId')
        if (departmentId) {
          return jobNamesForSelect(this, [departmentId])
        }

        return jobNamesForSelect(this)
      },
      itemCodes() {
        const departmentId = this.$store.get('priceRules@edit.departmentId')
        if (departmentId) {
          const filteredICs = _.filter(this.allItemCodes, (itemCode) => itemCode.departmentId === departmentId)
          return kvpsForSelectTheWorks(filteredICs, {
            sortBy: 'name',
            labelProp: 'name',
            valueProp: 'id',
            extraValue: 'qbClass'
          })
        }
        return []
      }
    },
    methods: {
      hasMoreThanOneOfClientDefaultOrLocationOrProjectDefault() {
        let booleanCount = 0

        if (this.edit.clientDefault === true) {
          booleanCount++
        }

        if (this.edit.location === true) {
          booleanCount++
        }

        if (this.edit.projectDefault === true) {
          booleanCount++
        }

        return booleanCount > 1
      },
      showInvalidAutocompleteWarning(refAndPathName) {
        // $ref has to match prop in store
        return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`priceRules/edit@${refAndPathName}`))
      },
      fieldNotValidError(field) {
        return autocompleteTextButNoValueMessage(field)
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          const savePayload = this.$store.get('priceRules/savePayload', 'price-rules')

          const response = await this.$store.dispatch('save', savePayload)

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            notifySuccess(this, 'Price Rule Saved Successfully')
            this.$eventHub.$emit('priceRuleSaved', response.data)
            this.closeModal()
          } else {
            notifyError(this, 'Error Saving Price Rule', response.errors)
          }
        }
        this.isProcessing = false
      },
      setExpiryDate() {
        if (this.expiryDate) {
          this.$store.set('priceRules/edit@expiry', utcToLocal(this.expiryDate))
        }
      },
      verifyCitySelected() {
        if (!this.$store.get('priceRules/edit@city') || !this.localCity) {
          this.$eventHub.$emit('show-modal-6', 'No City Error', null, '500px')
        }
      },
      closeModal() {
        this.$emit('close')
      },
      maybeClearHourlyRate(hourly) {
        if (!hourly) {
          this.$store.set('priceRules/edit@hourlyRate', 0)
        }
      },
      setDepartmentId(departmentName) {
        this.$store.set('priceRules/edit@departmentId', null)
        if (departmentName) {
          const department = objectBy(this.departments, 'label', departmentName)
          if (department) {
            this.$store.set('priceRules/edit@departmentId', department.value)
          }
        }
      },
      setTaskNameIdAndName(taskName) {
        this.$store.set('priceRules/edit@taskNameId', null)
        this.$store.set('priceRules/edit@taskName', null)
        if (taskName) {
          this.$store.set('priceRules/edit@taskNameId', taskName.value)
          this.$store.set('priceRules/edit@taskName', taskName.label)
        }
      },
      setJobName(jobName) {
        this.$store.set('priceRules/edit@jobName', null)
        if (jobName) {
          this.$store.set('priceRules/edit@jobName', jobName.label)
        }
      },
      findCompany(text, type) {
        return findCompany(this, text, type)
      },
      setCompany(company) {
        if (this.newCompany.builder) {
          this.setBuilder(company)
        } else if (this.newCompany.client) {
          this.setClient(company)
        }
        this.resetLocalCompany()
      },
      resetLocalCompany(type) {
        if (type && type === Constants.COMPANY.TYPES.CLIENT) {
          this.selectedClient = { id: null, name: null }
        }
        if (type && type === Constants.COMPANY.TYPES.BUILDER) {
          this.selectedBuilder = { id: null, name: null }
        }
        this.newCompany.client = false
        this.newCompany.builder = false
      },
      findBuilders(text, cb) {
        if (autocompleteReady(text)) {
          this.$store.set('priceRules/edit@builderId', null)
          this.$store.set('priceRules/edit@builder', null)
          this.findCompany(text, Constants.COMPANY.TYPES.BUILDER)
        }
        cb(this.autocompleteBuilders)
      },
      setBuilder(builder) {
        if (builder) {
          this.selectedBuilder.id = builder.id
          this.$store.set('priceRules/edit@builderId', builder.id)
          this.$store.set('priceRules/edit@builder', builder.name)
          this.$store.commit('companies/autocompleteResultsBuilder', [])
        }
      },
      verifyBuilderAutocompleteSelected() {
        if (!this.newCompany.builder && _.get(this, 'selectedBuilder.name')) {
          verifyAutocompleteSelected(this, 'priceRules/edit@builder', 'builder', this.selectedBuilder.name)
        }
      },
      findClients(text, cb) {
        if (autocompleteReady(text)) {
          this.$store.set('priceRules/edit@clientId', null)
          this.$store.set('priceRules/edit@client', null)
          this.findCompany(text, Constants.COMPANY.TYPES.CLIENT)
        }
        cb(this.autocompleteClients)
      },
      setClient(client) {
        if (client) {
          this.selectedClient.id = client.id
          this.$store.set('priceRules/edit@clientId', client.id)
          this.$store.set('priceRules/edit@client', client.name)
          this.$store.commit('companies/autocompleteResultsClient', [])
        }
      },
      verifyClientAutocompleteSelected() {
        if (!this.newCompany.client && _.get(this, 'selectedClient.name')) {
          verifyAutocompleteSelected(this, 'priceRules/edit@client', 'client', this.selectedClient.name)
        }
      },
      async findCommunities(text, cb) {
        this.$store.set('priceRules/edit@community', null)
        await findCommunities(this, text, cb, 'priceRules/edit@communityId')
      },
      setCommunity(community) {
        if (community) {
          this.localCommunity = community.name
          this.$store.set('priceRules/edit@communityId', community.id)
          this.$store.set('priceRules/edit@community', community.name)
        }
      },
      noCommunitySelected() {
        this.localCommunity = null
      },
      verifyCommunityAutocompleteSelected() {
        verifyAutocompleteSelected(this, 'priceRules/edit@community', 'community', this.localCommunity)
      },
      async findCities(text, cb) {
        await findCities(this, text, cb, 'priceRules/edit@city')
      },
      setCityLoadCounties(city) {
        this.resetDependentAutocompleteFields()
        this.localCity = city.name
        this.$store.set('priceRules/edit@city', city.name)
        this.counties = kvpsForSelectFromArray(city.counties)
      },
      resetDependentAutocompleteFields() {
        this.counties = []
        this.localStreetName = null
        this.$store.set('address/cities', [])
        this.$store.set('priceRules/edit@city', null)
        this.$store.set('priceRules/edit@streetName', null)
        this.$store.set('priceRules/edit@county', null)
      },
      verifyCityAutocompleteSelected() {
        if (this.localCity !== this.$store.get('priceRules/edit@city')) {
          verifyAutocompleteSelected(this, 'priceRules/edit@city', 'city', this.localCity)
          this.resetDependentAutocompleteFields()
        }
      },
      clearCity() {
        this.localCity = null
      },
      async findStreets(text, cb) {
        await findStreets(this, text, cb, 'priceRules/edit@')
      },
      setStreet(street) {
        if (street) {
          this.$store.set('priceRules/edit@streetName', street.name)
          this.localStreetName = street.name
        }
      },
      clearStreet() {
        this.localStreetName = null
      },
      verifyStreetNameAutocompleteSelected() {
        verifyAutocompleteSelected(this, 'priceRules/edit@streetName', 'street', this.localStreetName)
      },
      async findLegalSubdivisions(text, cb) {
        await findLegalSubdivisions(this, text, cb, 'priceRules/edit@')
      },
      setLegalSubdivision(legalSubdivision) {
        if (legalSubdivision) {
          this.localLegalSubdivision = legalSubdivision.name
          this.$store.set('priceRules/edit@legalSubdivisionId', legalSubdivision.id)
          this.$store.set('priceRules/edit@legalSubdivision', legalSubdivision.name)
        }
      },
      clearLegalSubdivision() {
        this.localLegalSubdivision = null
      },
      verifyLegalSubdivisionAutocompleteSelected() {
        verifyAutocompleteSelected(this, 'priceRules/edit@legalSubdivision', 'legal subdivision', this.localLegalSubdivision)
      },
      clientDefaultHasClient() {
        const self = this
        this.$validator.extend('clientDefaultHasClient', {
          getMessage() {
            return 'You must select a client when configuring a default price rule.'
          },
          validate() {
            return !(self.edit.clientDefault === true && !self.selectedClient.id)
          }
        })
        this.$validator.attach({name: 'client', rules: 'clientDefaultHasClient'})
      },
      locationHasClientOrProject() {
        const self = this
        this.$validator.extend('locationHasClientOrProject', {
          getMessage() {
            return 'You must select a client and/or project when configuring a location price rule.'
          },
          validate() {
            return !(self.edit.location === true && !self.selectedClient.id && !self.edit.projectName)
          }
        })
        this.$validator.attach({name: 'client', rules: 'locationHasClientOrProject'})
      },
      locationHasAddressFields() {
        const self = this
        this.$validator.extend('locationHasAddressFields', {
          getMessage() {
            return 'You must select a city and at least two address fields when configuring a location price rule.'
          },
          validate() {
            return self.edit.location === true && !!self.localCity && self.addressFieldCount >= 2
          }
        })
        this.$validator.attach({name: 'location', rules: 'locationHasAddressFields'})
      },
      projectDefaultHasProject() {
        const self = this
        this.$validator.extend('projectDefaultHasProject', {
          getMessage() {
            return 'You must include a project name when configuring a default project price rule.'
          },
          validate() {
            return !(self.edit.projectDefault === true && !self.edit.projectName)
          }
        })
        this.$validator.attach({name: 'projectName', rules: 'projectDefaultHasProject'});
      },
      clientDefaultOrLocationOrProjectDefault() {
        const self = this
        this.$validator.extend('clientDefaultOrLocationOrProjectDefault', {
          getMessage() {
            return 'You must select one of Client Default, Project Default, or Location.'
          },
          validate() {
            return !self.hasMoreThanOneOfClientDefaultOrLocationOrProjectDefault()
          }
        })
        this.$validator.attach({name: 'clientDefault', rules: 'clientDefaultOrLocationOrProjectDefault'});
        this.$validator.attach({name: 'projectDefault', rules: 'clientDefaultOrLocationOrProjectDefault'});
        this.$validator.attach({name: 'location', rules: 'clientDefaultOrLocationOrProjectDefault'});
      },
      clientDefaultOrLocationOrProjectDefaultAndLocationHasAddressFields() {
        const self = this
        this.$validator.extend('clientDefaultOrLocationOrProjectDefaultAndLocationHasAddressFields', {
          getMessage() {
            return 'You must select one of Client Default, Project Default, or Location.'
          },
          validate() {
            return !(self.hasMoreThanOneOfClientDefaultOrLocationOrProjectDefault()
              || (self.edit.location === true && self.addressFieldCount < 2))
          }
        })
        this.$validator.attach({name: 'location', rules: 'clientDefaultOrLocationOrProjectDefaultAndLocationHasAddressFields'});
      },
      hourlyHasRate() {
        const self = this
        this.$validator.extend('hourlyHasRate', {
          getMessage() {
            return 'You must include an hourly rate greater than zero.'
          },
          validate() {
            return !(self.edit.hourly === true && self.edit.hourlyRate === 0)
          }
        })
        this.$validator.attach({name: 'hourlyRate', rules: 'hourlyHasRate'})
      },
      getUserDisplayName(userId) {
        return this.$store.get('users/displayName', userId)
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    async beforeMount() {
      this.clientDefaultOrLocationOrProjectDefaultAndLocationHasAddressFields()
      this.clientDefaultOrLocationOrProjectDefault()
      this.projectDefaultHasProject()
      this.clientDefaultHasClient()
      this.locationHasClientOrProject()
      this.locationHasAddressFields()
      this.hourlyHasRate()
      this.$store.commit('priceRules/resetEdit')
      await Promise.all([
        this.$store.cache.dispatch('camunda/fetchAllPtracDeployments'),
        this.$store.cache.dispatch('tasks/names/fetchAll'),
        this.$store.cache.dispatch('types/fetchByEntityType', 'Project'),
        this.$store.cache.dispatch('quickbooks/fetchAll')
      ])
    },
    async mounted() {
      this.$eventHub.$on('companySaved', this.setCompany)
      this.$eventHub.$on('noCompanySelected', this.resetLocalCompany)
      this.$eventHub.$on('citySaved', this.setCityLoadCounties)
      this.$eventHub.$on('noCitySaved', this.clearCity)
      this.$eventHub.$on('legalSubdivisionSaved', this.setLegalSubdivision)
      this.$eventHub.$on('noLegalSubdivisionSaved', this.clearLegalSubdivision)
      this.$eventHub.$on('streetSaved', this.setStreet)
      this.$eventHub.$on('noStreetSaved', this.clearStreet)
      this.$eventHub.$on('communitySaved', this.setCommunity)
      this.$eventHub.$on('noCommunitySelected', this.noCommunitySelected)

      if (this.data && this.data.id) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.PRICE_RULES,
          id: this.data.id
        })

        if (OK === response.status) {
          this.displayAuditFields = true
          this.$store.set('priceRules/edit', response.data)
          const priceRulesEdit = this.$store.get('priceRules/edit')

          this.selectedTaskName = priceRulesEdit.taskName
          this.selectedJobName = priceRulesEdit.jobName
          this.localCity = priceRulesEdit.city
          this.selectedBuilder.name = priceRulesEdit.builder
          this.selectedBuilder.id = priceRulesEdit.builderId
          this.selectedClient.name = priceRulesEdit.client
          this.selectedClient.id = priceRulesEdit.clientId
          this.localCommunity = priceRulesEdit.community
          this.localLegalSubdivision = priceRulesEdit.legalSubdivision
          this.localStreetName = priceRulesEdit.streetName
          this.expiryDate = priceRulesEdit.expiry
        }
      }
    },
    destroyed() {
      this.$eventHub.$off('companySaved')
      this.$eventHub.$off('noCompanySelected')
      this.$eventHub.$off('citySaved')
      this.$eventHub.$off('noCitySaved')
      this.$eventHub.$off('legalSubdivisionSaved')
      this.$eventHub.$off('noLegalSubdivisionSaved')
      this.$eventHub.$off('streetSaved')
      this.$eventHub.$off('noStreetSaved')
      this.$eventHub.$off('communitySaved')
      this.$eventHub.$off('noCommunitySelected')
    },
    watch: {
      'selectedBuilder.name': {
        handler: function (selectedBuilder) {
          if (!selectedBuilder) {
            this.$store.commit('companies/autocompleteResultsBuilder', [])
            this.selectedBuilder.id = null
            this.$store.set('priceRules/edit@builder', null)
            this.$store.set('priceRules/edit@builderId', null)
          }
        }
      },
      'selectedClient.name': {
        handler: function (selectedClient) {
          if (!selectedClient) {
            this.$store.commit('companies/autocompleteResultsClient', [])
            this.selectedClient.id = null
            this.$store.set('priceRules/edit@client', null)
            this.$store.set('priceRules/edit@clientId', null)
          }
        }
      },
      localCity: {
        handler: function (city) {
          if (!city) {
            this.resetDependentAutocompleteFields()
          }
        }
      },
      localStreetName: {
        handler: function (localStreetName) {
          if (!localStreetName) {
            this.$store.commit('address/streets', [])
            this.$store.set('priceRules/edit@streetName', null)
          }
        }
      },
      localCommunity: {
        handler: function (localCommunity) {
          if (!localCommunity) {
            this.$store.commit('communities/results', [])
            this.$store.set('priceRules/edit@community', null)
          }
        }
      },
      localLegalSubdivision: {
        handler: function (localLegalSubdivision) {
          if (!localLegalSubdivision) {
            this.$store.commit('legalSubdivisions/results', [])
            this.$store.set('priceRules/edit@legalSubdivision', null)
          }
        }
      }
    }
  }
</script>

<style scoped>
  .m-top-40 {
    margin-top: 40px;
  }
  label {
    display: block;
  }

  .col-md-1, .col-md-2, .col-md-3, .col-md-4 {
    padding-left: 5px;
    padding-right: 5px;
  }
</style>
